import Link from 'next/link';
import clsx from 'clsx';
import { removeBaseUrl, addBaseUrl } from '@/utils/url';
import { WagtailPage, WagtailStreamfieldImage } from '@/types';
import Image from 'next/image';
import RawHtml from '@components/RawHtml/RawHtml';

interface Props {
  title: string;
  text: string;
  image: WagtailStreamfieldImage;
  button_page: WagtailPage | null;
  button_url: string | null;
  button_text: string;
  layout: 'full_width' | 'content_width';
}

function CTA(props: Props) {
  const {
    button_page: buttonPage,
    button_url: buttonUrl,
    button_text: buttonText,
    title,
    image,
    text,
    layout,
  } = props;

  return (
    <div
      className={clsx('streamfield cta', {
        'cta--small': layout === 'content_width',
      })}
    >
      <div className='container'>
        <div className='box'>
          {title ? <div className='box__header'>{title}</div> : ''}
          <div className='box__text'>
            <RawHtml html={text} />
          </div>
          <Link
            href={buttonPage ? removeBaseUrl(buttonPage.full_url) : buttonUrl || '/'}
            className='button button--primary'
            target={buttonUrl ? '_blank' : '_self'}
          >
            {buttonText}
          </Link>
        </div>
      </div>
      <Image
        src={addBaseUrl(image.file.src)}
        alt={image.file.alt}
        layout='fill'
        objectFit='cover'
        className='cta__image'
      />
    </div>
  );
}

export default CTA;
